import { terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import {
  ReprocessTenantSignalImportRawRowsBodySchema,
  ReprocessTenantSignalImportRawRowsResponseSchema,
} from './validation-hub.schemas';

export const cockpitValidationHubRoutes = {
  reprocessTenantSignalImportRawRows: terraContract
    .meta({ permissions: ['Cockpit Admin'] })
    .route({
      method: 'POST',
      path: '/validation-hub/reprocess-raw-rows',
      summary:
        'Re-fire the signal import pipeline for tenant raw rows missing drafts',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: ReprocessTenantSignalImportRawRowsBodySchema }))
    .output(ReprocessTenantSignalImportRawRowsResponseSchema),
} as const;
